/*
 * Module for the New Benefits Estimate page
*/
rs.module("ui/content/communications/onlineforms/paymentmethod",

    [
        "common/select-helper",
        "controls/components/event-banner",
    ],

    function (selectHelper, eventBanner) {
        // Initialize the module
        function initialize(jsSelectors) {

            var stepContainer = $.js(jsSelectors.stepContainer);
            var paymentMethodRadio = stepContainer.js(jsSelectors.paymentMethodRadio, { multiple: true });
            var paymentMethodDescriptionDiv = stepContainer.js(jsSelectors.paymentMethodDescriptionDiv, { multiple: true });

            var selectedIndex = paymentMethodRadio.index(paymentMethodRadio.filter(":checked"));
            if (selectedIndex && selectedIndex >= 0) {
                showSelectedPaymentMethodDescription(selectedIndex);
            }

            // Handle the paymentMethodRadio click event
            paymentMethodRadio.on("click", function () {

                var selectedIndex = paymentMethodRadio.index(this);
                showSelectedPaymentMethodDescription(selectedIndex);
            });

            // Show (slide down) the description for the selected payment method
            function showSelectedPaymentMethodDescription(selectedIndex) {

                // Close all quickly
                paymentMethodDescriptionDiv.stop(true, true).slideUp(150);

                // Open the selected one
                paymentMethodDescriptionDiv.eq(selectedIndex).stop(true, true).slideDown(150);
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);